// Layout.js
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({openLoginModal, openRegisterModal,children }) => {
    return (
        <>
            <Navbar openLoginModal={openLoginModal} openRegisterModal={openRegisterModal} />
            {children}
            <Footer />
        </>
    );
};

export default Layout;
